import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import type { RestBulkUpsertProductOverlays } from "@KassaroAB/shared/types/productOverlay";
import {
  bulkUpsertProductOverlaysApi,
  getProductOverlaysApi,
} from "../api/productOverlaysApi";

export const productOverlaysQueryKey = (storeId: StoreId | null) =>
  ["stores", storeId, "productOverlays"] as const;

export const useGetProductOverlaysQuery = (storeId: StoreId | null) => {
  return useQuery({
    queryKey: productOverlaysQueryKey(storeId),
    queryFn: () => getProductOverlaysApi(storeId!),
    enabled: !!storeId,
  });
};

export const useBulkUpsertProductOverlaysMutation = (
  storeId: StoreId | null,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (updates: RestBulkUpsertProductOverlays["updates"]) =>
      bulkUpsertProductOverlaysApi(storeId!, updates),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: productOverlaysQueryKey(storeId),
      });
    },
  });
};
